import { render, staticRenderFns } from "./AmountSectionContainer.vue?vue&type=template&id=452975ee&scoped=true&"
import script from "./AmountSectionContainer.vue?vue&type=script&lang=ts&"
export * from "./AmountSectionContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AmountSectionContainer.vue?vue&type=style&index=0&id=452975ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452975ee",
  null
  
)

export default component.exports